<template>
    <section>
        <v-layout row style="border-bottom: 1px solid lightgray;">
            <v-layout xs4 style="padding-top: 17px;border-right: 1px solid lightgray;" row>
                <v-flex style="font-size: 18px;padding: 0px 8px;text-align: center;font-weight: bold;padding-top: 6px;">Filter :</v-flex>
                <v-text-field v-model="SearchText" style="margin: 0px;padding: 0px 16px;height: 44px;" label='Search Here'></v-text-field>
                <v-btn icon>
                    <v-icon @click="SearchNow">search</v-icon>
                </v-btn>
            </v-layout>
            <v-layout xs4 style="margin: 0px 24px;padding-top: 6px;border-right: 1px solid lightgrey;" row>
                <v-flex>
                    <v-menu v-model="menu1"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="From_Date"
                                            label="Pick From Date"
                                            clearable
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="From_Date" @input="menu1 = false"></v-date-picker>
                </v-menu>
                </v-flex>
                <v-flex>
                     <v-menu v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="To_Date"
                                        label="Pick To date"
                                        prepend-icon="event"
                                        clearable
                                        readonly
                                        v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="To_Date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-flex>
                <v-btn icon style="margin: 0px 14px;margin-top: 13px;">
                    <v-icon @click="SearchNow">search</v-icon>
                </v-btn>
            </v-layout>
            <v-layout xs4 style="margin-top: 14px;" row>
                <v-btn :disabled='!Transactions.length > 0' @click="CSVExport">Export</v-btn>
            </v-layout>
        </v-layout>
        <v-flex style="margin: 15px 55px;">
             <v-data-table :headers="headers" 
                           :items="Transactions" 
                           hide-actions
                           class="elevation-1" 
                           style="margin-bottom: 10px;"
                           disable-initial-sort
                           :loading='loading' 
                           loading-text="Loading... Please wait">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ new Date(props.item.Transaction_Date).toLocaleDateString() }}</td>
                        <td class="text-xs-center">{{ props.item.Email }}</td>
                        <td class="text-xs-center">
                            {{ props.item.Items.map(x => { 
                                if(x['Course_Title']) { 
                                    return x['Course_Title'] 
                                }else{ 
                                    return  x['Project_Title']
                                } 
                             }).join(' , ') 
                            }}
                        </td>
                        <td class="text-xs-center">{{ props.item.Payment_Type }} | {{ props.item.Sales_Via }}</td>
                        <td class="text-xs-center">{{ props.item.Discounted_Amount }}</td>
                        <td class="text-xs-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="primary" class="clsForActions" @click="OpenDialog(props.item)" dark v-on="on">visibility</v-icon>
                                </template>
                                <span>View</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
            <app-transaction-details ref="ViewDetails" :dialog='TransactionDetailsDialog' @close='CloseDialog'></app-transaction-details>
        </v-flex>
    </section>
</template>

<script>

import appTransactionDetails from '../dialogs/TransactionDetails'
export default {
    components:{
        appTransactionDetails
    },
    props : ['Course_Type','Purchase_Type','Status'],
    data(){

        return {

            headers                     : [ { text: 'Transaction Date',value: 'Transaction_Date' },
                                            { text: 'Purchaser' , value : 'Email'},
                                            { text: 'Item Name' },
                                            { text: 'Purchase | Sales Via' },
                                            { text: 'Amount Paid',value: 'Discounted_Amount' },
                                            { text: ' ' } ],
            Transactions                : [],
            pages                       : 1,
            records                     : 0,
            TransactionDetailsDialog    : false,
            SearchText                  : "",
            loading                     : false,
            From_Date                   : null,
            To_Date                     : null,
            menu1                       : false,
            menu2                       : false

        }
    },
    watch: { 
        SearchText() {
            if(this.SearchText.length > 4){

                this.SearchNow()

            }else if(this.SearchText.length < 4){

                this.GetDataFromDB({ 'limit':10, 'page' : 1 })
            }
        }
    },
    methods:{
        CloseDialog(){
            this.TransactionDetailsDialog = false
        },
        OpenDialog(item){
            this.$refs.ViewDetails.DisplayDetails(item)
            this.TransactionDetailsDialog = true
        },
        SearchNow(){

            this.loading = true
            let data = { 'limit' : 10, 'page' : this.pages ,'Status' : this.Status.toString() }
            this.SearchText ? data['SearchText'] = this.SearchText : ""
            this.From_Date ? data['From_Date']   = new Date(this.From_Date).setHours(0,0,0,0) : ""
            this.To_Date ? data['To_Date']       = new Date(this.To_Date).setHours(23,59,59,59) : ""
            this.GetDataFromDB(data)
        },
        GetNextSetOfData(){

            this.loading = true
            let data = { 'limit' : 10, 'page' : this.pages , 'Status' : this.Status.toString()}
            this.SearchText ? data['SearchText'] = this.SearchText : ""
            this.From_Date ? data['From_Date']   = new Date(this.From_Date).setHours(0,0,0,0) : ""
            this.To_Date ? data['To_Date']       = new Date(this.To_Date).setHours(23,59,59,59) : ""
            this.GetDataFromDB(data)

        },
        GetDataFromDB(data){ 
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/payment/transactions`,data)
                        .then(response =>{
                            
                            this.Transactions = response["data"]["response"]
                            this.records      = response["data"]["Records"]
                            this.loading      = false
        
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
        },
        CSVExport() {
            
            let data = {}
            this.SearchText ? data['SearchText'] = this.SearchText : ""
            this.From_Date ? data['From_Date']   = new Date(this.From_Date).setHours(0,0,0,0) : ""
            this.To_Date ? data['To_Date']       = new Date(this.To_Date).setHours(23,59,59,59) : ""

            this.$http.post(`${this.$store.getters.GetProductionUrl}/payment/export`,data)
                        .then(response =>{
                            
                            if(response && response['data'] && response['data']['response']){
                                
                                let FileName = Object.keys(data).length > 0 ? Object.values(data).join('_') : "Complete"
                                let csvContent = "data:text/csv;charset=utf-8,";
                                csvContent += response['data']['response']
                                const CSV_data = encodeURI(csvContent);
                                const link = document.createElement("a");
                                link.setAttribute("href", CSV_data);
                                link.setAttribute("download", `Sales_${FileName}.csv`);
                                link.click();

                            }else{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Downloading","Color":"red","Close": false });
                            }
        
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        }
    },
    mounted(){
        this.GetDataFromDB({ limit:10, page : this.pages ,'Status' : this.Status.toString() , "Course_Type" : this.Course_Type , "Purchase_Type": this.Purchase_Type })
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>